var render = function render(_c,_vm){return _c('div',{class:[_vm.data.staticClass, 'block', 'space-y-2']},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }